import React, { useEffect, useState } from 'react';
import { Button, TextField, Box, Alert, Snackbar, Typography } from '@mui/material';
import useSendVerification from '../api/app/sendVerification';
import register from '../api/app/register';

const RegisterPage = () => {
  // 狀態
  const [phone, setPhone] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [verificationCode, setVerificationCode] = useState('');
  const [showVerification, setShowVerification] = useState(false);

  const [passwordNotMatch, setPasswordNotMatch] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const [snackbar, setSnackbar] = useState({ open: false, msg: '' });

  // hook
  const [verificationData, setVerificationData] = useState({ phone: '' });
  const sendVerification = useSendVerification(verificationData);

  // 驗證欄位
  useEffect(() => {
    setPasswordNotMatch(password && confirmPassword && password !== confirmPassword);
  }, [password, confirmPassword]);

  useEffect(() => {
    setPhoneError(phone && phone.length !== 10);
  }, [phone]);

  // 驗證 Email
  useEffect(() => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setEmailError(email && !emailRegex.test(email));
  }, [email]);

  // 發送驗證碼
  const handleSendVerification = async () => {
    if (!phone || !email || !password || !confirmPassword || phoneError || emailError || passwordNotMatch) {
      setError('請填寫完整資料');
      return;
    }
    setLoading(true);
    try {
      const res = await sendVerification();
      if (res.code === "000") {
        setShowVerification(true);
        setError('');
      } else {
        setError(res.message || "發送驗證碼失敗");
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // 註冊
  const handleRegister = async () => {
    if (verificationCode.length !== 6) {
      setError('驗證碼長度不足');
      return;
    }
    setLoading(true);
    try {
      const res = await register(name, phone, password, email);
      if (res.code === "000") {
        setSnackbar({ open: true, msg: '註冊完成，請登入。' });
        setShowVerification(false);
      } else {
        setError(res.message || '註冊失敗');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box maxWidth={400} mx="auto" mt={5} p={3} boxShadow={2} borderRadius={2}>
      <Typography variant="h5" fontWeight="bold" mb={2}>註冊帳號</Typography>
      <TextField
        fullWidth margin="dense" color="secondary"
        label="手機號碼" value={phone} onChange={e => {
          setPhone(e.target.value); setVerificationData({ phone: e.target.value });
        }}
        error={phoneError}
        helperText={phoneError ? '手機號碼格式錯誤' : ''}
      />
      <TextField
        fullWidth margin="dense" color="secondary"
        label="姓名" value={name} onChange={e => setName(e.target.value)}
      />
      <TextField
        fullWidth margin="dense" color="secondary"
        label="電子信箱" type="email" value={email} onChange={e => setEmail(e.target.value)}
        error={emailError}
        helperText={emailError ? '電子信箱格式錯誤' : ''}
      />
      <TextField
        fullWidth margin="dense" color="secondary"
        label="密碼" type="password" value={password} onChange={e => setPassword(e.target.value)}
      />
      <TextField
        fullWidth margin="dense" color="secondary"
        label="確認密碼" type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)}
        error={passwordNotMatch}
        helperText={passwordNotMatch ? '密碼不相同' : ''}
      />
      {!showVerification && (
        <Button
          fullWidth variant="contained" color="primary" sx={{ mt: 2, fontWeight: 'bold' }}
          onClick={handleSendVerification} disabled={loading}
        >{loading ? '傳送中...' : '傳送驗證碼'}</Button>
      )}
      {showVerification && (
        <>
          <TextField
            fullWidth margin="dense" color="secondary"
            label="驗證碼" value={verificationCode} onChange={e => setVerificationCode(e.target.value)}
          />
          <Button
            fullWidth variant="contained" color="primary" sx={{ mt: 2, fontWeight: 'bold' }}
            onClick={handleRegister} disabled={loading}
          >{loading ? '註冊中...' : '完成註冊'}</Button>
        </>
      )}
      {error && <Alert severity="warning" sx={{ mt: 2 }}>{error}</Alert>}
      <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={() => setSnackbar({ open: false, msg: '' })} message={snackbar.msg} />
    </Box>
  );
};

export default RegisterPage;
